// Similar to LinkCell except it can render the link followed by an access denied icon with message
import { Tooltip, TooltipPosition } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import _ from 'underscore';

import { Messages } from '../../../../codegen/Localize';
import { CommonStyles } from '../../../../common/react/CommonStyles';
import { SharedWithMeSpaceStyle } from '../../SharedWithMe/style/SharedWithMeSpaceStyle';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { getLinkMarkup, ILink } from './LinkCell';

export function LinkCellWithAccessStatus(linkFn: (row: DataGrid.Row) => ILink): React.Factory<BodyCell.Props> {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render() {
          const link: ILink = linkFn(this.props.row);
          if (!link) {
            return null;
          }

          const renderLink = () => link.displayJustText ? (
              <span
                  title={link.hideTooltips || link.isAccessDenied ? null : (link.title || link.text)}
                  style={_.extend({display: 'block'}, CommonStyles.Layout.TextEllipsis, link.style)}>
            {link.text}
          </span>
          ) : getLinkMarkup(link, this.props.row);

          const iconClassName = link.isAccessDenied ? SharedWithMeSpaceStyle.AccessDeniedIcon : link.iconClassName;
          const renderIcon = () => iconClassName ? (
              <span data-tb-test-id='data-grid-cell-icon'
                    className={iconClassName}
                    style={{flex: 'none'}}/>
          ) : null;

          return link.isAccessDenied ? (
              <Tooltip
                  getContent={() => {
                    return <span>{Messages.permissionsRequiredTooltipLabel()}</span>;
                  }}
                  position={TooltipPosition.BottomRightCorner}>
            <span
                data-tb-test-id={link.testId}
                style={{...CommonStyles.Layout.FlexBlockLeftAndCenter, maxWidth: 'max-content', }}>
              {renderLink()}
              {renderIcon()}
            </span>
              </Tooltip>
          ) : (
              <span
                  data-tb-test-id={link.testId}
                  style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
            {renderLink()}
                {renderIcon()}
          </span>
          );
        }
      })
  );
}
